module.exports = __webpack_public_path__ + "796f5b6a69e5d2b7e34f695870fc01d1.png";